/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GradingConfigSnapshotResponseDefaultFormalParamsAnyOf } from './gradingConfigSnapshotResponseDefaultFormalParamsAnyOf';

export type GradingConfigSnapshotResponseDefaultFormalParams =
  GradingConfigSnapshotResponseDefaultFormalParamsAnyOf | null;
